import type { ReactNode } from "react";
import { MobyNetLogo } from "./moby-net-logo";

export function OnboardingPageLayout({
  form,
}: {
  title?: ReactNode;
  description?: ReactNode;
  form: ReactNode;
}) {
  return (
    <div className="fixed inset-0 overflow-hidden bg-black">
      {/* Background image — fixed, fills viewport with slight overscan */}
      <img
        src="/MobyNet-Hero-Hand-v2.svg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover scale-110 origin-right pointer-events-none select-none"
      />

      {/* Card overlay — fixed right, vertically centered, scrollable */}
      <div className="absolute inset-0 flex justify-end items-center p-4 sm:p-6">
        <div className="w-full max-w-sm min-w-0 max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-xl">
          {form}
        </div>
      </div>
    </div>
  );
}
